import { Component, HostListener,ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackbarService } from '../services/snackbar.service';
import { ApiServicesService } from '../services/api-services.service';
import { UserDetailsService } from '../services/user-details.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { UploadPhotosComponent } from "../upload-photos/upload-photos.component";
import { UploadPostComponent } from "../upload-post/upload-post.component";
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ImageModalComponent } from '../image-modal/image-modal.component';

@Component({
  selector: 'app-posts',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatInputModule, MatButtonModule, RouterLink],
  templateUrl: './posts.component.html',
  styleUrl: './posts.component.css'
})

export class PostsComponent implements OnDestroy {

  baseUrl: string = 'http://localhost:4200';
  profilePic: any;
  userData: any;
  userName: any;
  profileUserData: any = '';
  page: any = 1;
  limit: any = 10;
  totalPages: any = 1;
  isLoading = true;
  is_myProfile = false;
  @Input() is_activity: boolean = false;
  posts: any[] = [];
  shimmer = true;
  loading: boolean = false;
  allPostsLoaded: boolean = false;
  pge = 1;

  constructor(
    private userdetails: UserDetailsService,
    private apiService: ApiServicesService,
    private snackbarService: SnackbarService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
  ) { }


  fetchActivityPosts(): void {
    if (this.page && this.limit) {
      this.userdetails?.getAllPostActivity(this.page, this.limit);
    }
  }

  fetchProfilePosts(userId: string): void {
    if (userId && this.page && this.limit) {
      this.userdetails?.getAllPost(userId, this.page, this.limit);
    }
  }

  private userSubscription!: Subscription;
  posts_shimmer=false;

  ngOnInit() {
    this.shimmer = true;
    this.isLoading = true;
    this.posts = [];
    this.page = 1;
    const route = this.route.snapshot.params;

    this.userSubscription = this.userdetails.userdetails$.subscribe(
      (userData) => {

        if (userData !== null) {
          if (userData && userData.user) {
            this.userData = userData;
            this.posts = [];
            this.page = 1;
            this.profilePic = userData?.profile_pic || '';
            this.userName = userData?.user?.username;

            const currentTab = route['tab'];

            if (this.is_activity && currentTab === 'Activity') {
              this.fetchActivityPosts();
            } else if (!this.is_activity && currentTab === 'Profile') {
              this.fetchProfilePosts(userData.user._id);
            }
          }
        } else {
          this.shimmer = true;
          this.isLoading = true;
          this.posts_shimmer=true;


        }
      
      },
      (error) => {
        console.error('Error fetching user details:', error);
      }
    );


    this.userdetails.posts$.subscribe((response) => {
      if (response) {
        this.profileUserData = response?.userInfo;
        console.log('this.profileUserData',this.profileUserData)
        this.totalPages = this.is_activity ? response?.totalPages || 1 : response?.pagination?.totalPages || 1;
        const isFirstPage = this.is_activity
          ? response.currentPage == "1"
          : response.pagination?.currentPage == 1;
        if (isFirstPage) {
          this.posts = response?.posts || [];
        } else {
          this.posts = [...this.posts, ...(response?.posts || [])];
        }
        if (response.error || response.message == "No more post is available.") {
          this.totalPages = 1;
          this.posts = [];
        }
        this.isLoading = false;
        this.shimmer = false;
        this.posts_shimmer=false;
      }
    });
  }

  checkProfile(userName: any) {
    const is_myProfile = this.apiService.checkProfile(userName);
    if (is_myProfile) {
      return ['/my-profile', userName, 'Activity'];
    } else {
      return ['/member-profile/', userName, 'Profile'];
    }
  }

  @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef;
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    if (!this.scrollContainer) return;
  
    const target = this.scrollContainer.nativeElement as HTMLElement;
    const rect = target.getBoundingClientRect(); // Get element position relative to the viewport
    const windowHeight = window.innerHeight;
  
    // Check if the element is visible near the bottom of the viewport
    if (rect.bottom <= windowHeight + 100 && !this.isLoading && this.pge < this.totalPages) {
      this.shimmer = true;
      this.isLoading = true;
      const route = this.route.snapshot.params;
      if (this.is_activity && route['tab'] === 'Activity') {
        this.pge++;
        this.userdetails.getAllPostActivity(this.pge, this.limit);
      } else if (!this.is_activity && route['tab'] === 'Profile') {
        this.pge++;
        this.userdetails.getAllPost(this.userData?.user?._id, this.pge, this.limit);
      }
    }
  }
  
  getUsername(post: any): string {
    return this.is_activity ? post?.user?.username : post?.userID?.username;
  }

  getProfilePic(post: any): string {
    return this.is_activity ? post?.user?.thumbPic : this.profileUserData?.thumbPic;
  }

  getCategoryImage(post: any): any {
    const category = post?.postCategory?.name;
    if (category === 'cover_photo' || category === 'profile_photo') {
      return post?.postCategory?.categoryImage;
    }
    if (category === 'regular') {
      return post?.photo;
    }
    return null;
  }


  ngOnDestroy() {
    this.userdetails.allPosts.next('');
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }


   openImageModal(imageUrl: string): void {
      this.dialog.open(ImageModalComponent, {
        data: { imageUrl },
      });
    }

  getName(name: any) {
    if (name == 'regular') {
      return 'Photo';
    } else if (name == "cover_photo") {
      return 'Cover Photo';
    } else if (name == null) {
      return 'status update';
    } else {
      return 'Profile Photo';
    }
  }
}
